import * as React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { postMessageToParent } from '../../utils/postMessage';
import {
  PAYMENT_STATUS,
  POST_MESSAGE_CONTENT_MESSAGE,
  POST_MESSAGE_TYPE,
  STATUS_TIME_LENGTH
} from '../../common/constants';
import SamsungPayBox from '../../components/common/SamsungPayBox';
import SamsungPayHeader from '../../components/common/SamsungPayHeader';
import ReturnToStoreButton from '../../components/buttons/ReturnToStoreButton';
import cancelLogo from '../../assets/pay_online_payment_cancel_2.png';
import { useSelector } from 'react-redux';
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';
import { persistor } from '../../utils/store';

const cx = classNames.bind(styles);

export default function ErrorPage() {
  const { t } = useTranslation();
  const { sourceOrigin } = useSelector((state) => state.paymentClient);

  useEffect(() => {
    setTimeout(() => {
      postMessageToParent({
        type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
        content: {
          status: PAYMENT_STATUS.FAIL,
          message: POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_ERROR
        },
        sourceOrigin: sourceOrigin ? sourceOrigin : "*"
      });

      persistor.purge();
    }, STATUS_TIME_LENGTH.ERROR);
  }, []);

  return(
    <SamsungPayBox>
      <SamsungPayHeader headerMessage={t('pay.gsmpi.done.msg1')}/>
      <div className="mpi-dynamic-space-div"></div>
      <div className="mpi-content">
        <div>
          <div style={{textAlign: 'center'}}><img src={cancelLogo} alt="" className={cx('mpi-unable-img')}/></div>
          <div style={{textAlign: 'center'}} className={cx('mpi-body-msg-div1')}>{t('pay.gsmpi.error.msg')}</div>
        </div>
      </div>
      <div className="mpi-boxbottom">
        <ReturnToStoreButton reasonMessage={POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_ERROR}/>
      </div>
    </SamsungPayBox>
  );
}
